// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Emac_Zone = require("../emac/Emac_Zone.bs.js");
var Zone_Type = require("../zone/Zone_Type.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_String = require("../type/Type_String.bs.js");
var Emac_V4_Zone = require("../emac/v4/Emac_V4_Zone.bs.js");
var FeatureFlipping = require("../FeatureFlipping.bs.js");
var Js_null_undefined = require("@rescript/std/lib/js/js_null_undefined.js");

function isTeaserAvailableDefault(param) {
  return true;
}

function onLogoutCallback(param) {
  console.log("Account logout");
}

var defaultApi_loadNextPage = (function (param) {
    return Promise.resolve(null);
  });

var defaultApi_isTeaserAvailable = isTeaserAvailableDefault;

var defaultApi_getNextPageUrl = (function (_currentUrl, nextPageUrl) {
    return nextPageUrl;
  });

var defaultApi_getPageUrl = (function (currentUrl, _pageUrl) {
    return currentUrl;
  });

var defaultApi_getTrailerUrl = (function (url) {
    return url + "/trailer";
  });

var defaultApi_showPrivacyCenter = (function (param) {
    
  });

var defaultApi_subscribeToNewsletter = (function (param, param$1, param$2) {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: Curry._1(Type_String.SubscribeToNewsletter.$$Error.make, "default method, please provide a method subscribeToNewsletter")
              });
  });

var defaultApi_onLogoutCallback = onLogoutCallback;

var defaultApi_consentStatus = "unknown";

var defaultApi = {
  loadNextPage: defaultApi_loadNextPage,
  isTeaserAvailable: defaultApi_isTeaserAvailable,
  getNextPageUrl: defaultApi_getNextPageUrl,
  getPageUrl: defaultApi_getPageUrl,
  getTrailerUrl: defaultApi_getTrailerUrl,
  showPrivacyCenter: defaultApi_showPrivacyCenter,
  subscribeToNewsletter: defaultApi_subscribeToNewsletter,
  onLogoutCallback: defaultApi_onLogoutCallback,
  consentStatus: defaultApi_consentStatus
};

function defaultEnsuredApi_loadNextPage(param, param$1, param$2, param$3, param$4) {
  return Promise.resolve(null);
}

function defaultEnsuredApi_getNextPageUrl(_currentUrl, nextPageUrl) {
  return nextPageUrl;
}

function defaultEnsuredApi_getPageUrl(currentUrl, _page) {
  return currentUrl;
}

function defaultEnsuredApi_getTrailerUrl(url) {
  return url + "/trailer";
}

function defaultEnsuredApi_showPrivacyCenter(param) {
  
}

function defaultEnsuredApi_subscribeToNewsletter(param, param$1, param$2) {
  return Promise.resolve({
              TAG: /* Error */1,
              _0: Curry._1(Type_String.SubscribeToNewsletter.$$Error.make, "there is an error")
            });
}

var defaultEnsuredApi = {
  isTeaserAvailable: isTeaserAvailableDefault,
  loadNextPage: defaultEnsuredApi_loadNextPage,
  getNextPageUrl: defaultEnsuredApi_getNextPageUrl,
  getPageUrl: defaultEnsuredApi_getPageUrl,
  getTrailerUrl: defaultEnsuredApi_getTrailerUrl,
  showPrivacyCenter: defaultEnsuredApi_showPrivacyCenter,
  subscribeToNewsletter: defaultEnsuredApi_subscribeToNewsletter,
  onLogoutCallback: onLogoutCallback,
  consentStatus: "unknown"
};

function ensureApi(timeReferenceOpt, emacVersion, api) {
  var timeReference = timeReferenceOpt !== undefined ? Caml_option.valFromOption(timeReferenceOpt) : new Date();
  if (api !== undefined) {
    return {
            isTeaserAvailable: Belt_Option.getWithDefault(api.isTeaserAvailable, isTeaserAvailableDefault),
            loadNextPage: Belt_Option.getWithDefault(Belt_Option.map(api.loadNextPage, (function (loadNextPage, dateFormater, betweenDatesFormater, nextBroadcastDateFormater, zone, str) {
                        return Curry._1(loadNextPage, str).then(function (response) {
                                    return Js_null_undefined.fromOption(Belt_Option.flatMap((response == null) ? undefined : Caml_option.some(response), (function (resp) {
                                                      if (emacVersion === "v4") {
                                                        var nextPage = Emac_V4_Zone.nextPage_decode(resp);
                                                        if (nextPage.TAG === /* Ok */0) {
                                                          return Zone_Type.makeFromV4NextZone(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, zone, nextPage._0);
                                                        }
                                                        console.log("cant parse next page", nextPage._0);
                                                        return ;
                                                      }
                                                      var nextPage$1 = Emac_Zone.nextPage_decode(resp);
                                                      if (nextPage$1.TAG === /* Ok */0) {
                                                        return Zone_Type.makeFromNextZone(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, zone, nextPage$1._0);
                                                      }
                                                      console.log("cant parse next page", nextPage$1._0);
                                                    })));
                                  });
                      })), defaultEnsuredApi_loadNextPage),
            getNextPageUrl: Belt_Option.getWithDefault(Belt_Option.map(api.getNextPageUrl, (function (getNextPageUrl, baseUrl, nextPage) {
                        return Curry._2(getNextPageUrl, baseUrl, nextPage);
                      })), defaultEnsuredApi_getNextPageUrl),
            getPageUrl: Belt_Option.getWithDefault(Belt_Option.map(api.getPageUrl, (function (getPageUrl, baseUrl, page) {
                        return Curry._2(getPageUrl, baseUrl, page);
                      })), defaultEnsuredApi_getPageUrl),
            getTrailerUrl: Belt_Option.getWithDefault(api.getTrailerUrl, defaultEnsuredApi_getTrailerUrl),
            showPrivacyCenter: Belt_Option.getWithDefault(api.showPrivacyCenter, defaultEnsuredApi_showPrivacyCenter),
            subscribeToNewsletter: Belt_Option.getWithDefault(api.subscribeToNewsletter, defaultEnsuredApi_subscribeToNewsletter),
            onLogoutCallback: Belt_Option.getWithDefault(api.onLogoutCallback, onLogoutCallback),
            consentStatus: Belt_Option.getWithDefault(api.consentStatus, "unknown")
          };
  } else {
    return defaultEnsuredApi;
  }
}

var initialState_cdnUrl = Type_String.CdnUrl.empty;

var initialState_featureFlippings = FeatureFlipping.make(undefined);

var initialState_trackPixel = null;

var initialState_trackUserAction = null;

var initialState_trackPageView = null;

var initialState_serverTime = new Date();

var initialState = {
  api: defaultEnsuredApi,
  baseUrl: "",
  cdnUrl: initialState_cdnUrl,
  createVideoElement: undefined,
  featureFlippings: initialState_featureFlippings,
  trackPixel: initialState_trackPixel,
  trackUserAction: initialState_trackUserAction,
  trackPageView: initialState_trackPageView,
  vodStoreHomepageUrl: undefined,
  playStoreUrl: undefined,
  appStoreUrl: undefined,
  appGalleryUrl: undefined,
  serverTime: initialState_serverTime,
  ssoApiKey: "",
  ssoTokenApiKey: ""
};

function ensureVodStoreHomepageUrl(string) {
  if (string == null) {
    return ;
  } else {
    return Caml_option.some(string);
  }
}

function ensurePlayStoreUrl(string) {
  return Belt_Option.map((string == null) ? undefined : Caml_option.some(string), Type_String.PlayStoreUrl.make);
}

function ensureAppStoreUrl(string) {
  return Belt_Option.map((string == null) ? undefined : Caml_option.some(string), Type_String.AppStoreUrl.make);
}

function ensureAppGalleryUrl(string) {
  return Belt_Option.map((string == null) ? undefined : Caml_option.some(string), Type_String.AppGalleryUrl.make);
}

function getFeatureFlippingStatus(requestedFeature, state) {
  return FeatureFlipping.getStatus(requestedFeature, state.featureFlippings);
}

var Helpers = {
  ensureVodStoreHomepageUrl: ensureVodStoreHomepageUrl,
  ensurePlayStoreUrl: ensurePlayStoreUrl,
  ensureAppStoreUrl: ensureAppStoreUrl,
  ensureAppGalleryUrl: ensureAppGalleryUrl,
  getFeatureFlippingStatus: getFeatureFlippingStatus
};

var consentStatus = "unknown";

exports.isTeaserAvailableDefault = isTeaserAvailableDefault;
exports.onLogoutCallback = onLogoutCallback;
exports.consentStatus = consentStatus;
exports.defaultApi = defaultApi;
exports.defaultEnsuredApi = defaultEnsuredApi;
exports.ensureApi = ensureApi;
exports.initialState = initialState;
exports.Helpers = Helpers;
/* initialState Not a pure module */
